export default "__VITE_PUBLIC_ASSET__a74772f0__"